import { render, staticRenderFns } from "./ServerError.vue?vue&type=template&id=6c7bfdb7&scoped=true&"
import script from "./ServerError.vue?vue&type=script&lang=js&"
export * from "./ServerError.vue?vue&type=script&lang=js&"
import style0 from "./ServerError.vue?vue&type=style&index=0&id=6c7bfdb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7bfdb7",
  null
  
)

export default component.exports